module.exports = __webpack_public_path__ + "static/assets/1a375f587f65a466438a7e60100a8750.png";